import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import './ScrollUp.css';
import { FaArrowUp } from "react-icons/fa";

function ScrollUp() {
    const { t } = useTranslation();
    const [showScrollUp, setShowScrollUp] = useState(false);

    const handleScrollUp = () => {
        if (window.scrollY >= 350) {
            setShowScrollUp(true);
        } else {
            setShowScrollUp(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScrollUp);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScrollUp);
        };
    }, []);

    return (
        <button
            className={`scroll-up ${showScrollUp ? 'show' : ''}`}
            onClick={scrollToTop}
            aria-label={t('scrollUp.label')}
            title={t('scrollUp.label')}
        >
            <FaArrowUp />
        </button>
    );
}

export default ScrollUp;
